"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const order_1 = require("@/api/order");
const date_1 = require("@/utils/date");
const register_1 = require("@/api/register");
const ali_oss_1 = __importDefault(require("ali-oss"));
const moment_1 = __importDefault(require("moment"));
let OrderDetail = class OrderDetail extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.detail = {};
        this.product = [];
        this.plans = [];
        this.curFile = {};
        this.fileList = [];
        this.currentId = '';
        this.uploadPhoto = [];
        this.dialogVisible = false;
        this.marks = ['待确认', '审核中', '已确认', '已付款', '生产中', '待发货', '已出运', '已收货', '已完成'];
        this.form = {
            id: '',
            score: 0,
            content: '',
            photo: '',
            loginToken: this.userInfo.loginToken
        };
        this.active = 0;
        this.contacInfo = {
            email: "",
            faceBook: "",
            lastOnlineTime: '',
            phone: "",
            qqmsn: "",
            skype: "",
            wechat: "",
            whatsApp: ""
        };
        this.wareHouseFlag = false;
        this.quoted = false;
    }
    viewContract(a) {
        window.open(a, '_blank');
    }
    getContact(id) {
        order_1.getContact({ id: id, loginToken: this.userInfo.loginToken }).then(res => {
            //console.log(res)
            this.contacInfo = JSON.parse(JSON.stringify(res));
            this.dialogVisible = true;
        });
    }
    goDetail(row) {
        this.$router.push(`/goodDetail/${row.itemNo}`);
    }
    getDate(date) {
        return date_1.getDateStr(date);
    }
    _copy(context) {
        // 创建输入框元素
        let oInput = document.createElement('input');
        // 将想要复制的值
        oInput.value = context;
        // 页面底部追加输入框
        document.body.appendChild(oInput);
        // 选中输入框
        oInput.select();
        // 执行浏览器复制命令
        document.execCommand('Copy');
        // 弹出复制成功信息
        this.$message.success('复制成功');
        // 复制后移除输入框
        oInput.remove();
    }
    // copyOrder () {
    //   copyOrder({ id: this.currentId, loginToken: this.userInfo.loginToken }).then(res => {
    //     this.$notify.success('copy success')
    //     const routeLink = this.$router.resolve({
    //       path: `/orderDetail/${res}`
    //     })
    //     window.open(routeLink.href, '_blank')
    //     // this.$router.push(`/orderDetail/${res}`)
    //   })
    // }
    copyOrder() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        order_1.copyOrder({ id: this.currentId, loginToken: this.userInfo.loginToken }).then(res => {
            loading.close();
            sessionStorage.setItem('id', this.currentId);
            this.$router.push(`/car`);
            //this.$notify.success('copy success')
            // const routeLink = this.$router.resolve({
            //   path: `/orderDetail/${res}`
            // })
            // window.open(routeLink.href, '_blank')
        });
    }
    completeOrder() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        order_1.completeOrder({ id: this.currentId, loginToken: this.userInfo.loginToken }).then(res => {
            sessionStorage.setItem('id', this.currentId);
            this.orderDetail(this.currentId);
            //this.$notify.success('copy success')
            // const routeLink = this.$router.resolve({
            //   path: `/orderDetail/${res}`
            // })
            // window.open(routeLink.href, '_blank')
        });
        loading.close();
    }
    orderDetail(id) {
        order_1.orderDetail({ id: id, loginToken: this.userInfo.loginToken }).then(res => {
            res.detail.orderDate ? res.detail.orderDate = moment_1.default(res.detail.orderDate).format('YYYY-MM-DD') : '';
            this.detail = res.detail;
            this.product = res.items;
            res.items.forEach((val) => {
                if (val.wareHouseName)
                    this.wareHouseFlag = true;
            });
            this.plans = res.plans;
            let active;
            switch (res.detail.salesOrderStatus) {
                case '待确认':
                    active = 1;
                    break;
                case '审核中':
                    active = 2;
                    break;
                case '已确认':
                    active = 3;
                    break;
                case '已付款':
                    active = 4;
                    break;
                case '生产中':
                    active = 5;
                    break;
                case '待发货':
                    active = 6;
                    break;
                case '已出运':
                    active = 7;
                    break;
                case '已收货':
                    active = 8;
                    break;
                case '已完成':
                    active = 9;
                    break;
                default:
                    active = 1;
            }
            this.active = active;
        });
    }
    quotedDetail(id) {
        order_1.getOneQuo({ id: id, loginToken: this.userInfo.loginToken }).then(res => {
            res.detail.quotationDate ? res.detail.orderDate = moment_1.default(res.detail.quotationDate).format('YYYY-MM-DD') : '';
            res.detail.salesOrderNo = res.detail.quotationNo;
            res.detail.salesOrderStatus = res.detail.quotationStatus;
            this.detail = res.detail;
            this.product = res.items;
            res.items.forEach((val) => {
                if (val.wareHouseName)
                    this.wareHouseFlag = true;
            });
            this.plans = res.plans;
            let active;
            switch (res.detail.quotationStatus) {
                case '待确认':
                    active = 1;
                    break;
                case '已确认':
                    active = 2;
                    break;
                case '已报价':
                    active = 3;
                    break;
                case '已下单':
                    active = 4;
                    break;
                default:
                    active = 1;
            }
            this.active = active;
        });
    }
    add(id) {
        this.form.id = id;
        this.dialogVisible = true;
    }
    addMoccent() {
        this.form.photo = String(this.uploadPhoto);
        order_1.addComment(this.form).then(res => {
            this.$notify.success('send success');
            this.dialogVisible = false;
            this.orderDetail(this.currentId);
        });
    }
    onChange(file, fileList) {
        this.curFile = file;
        this.fileList = fileList;
    }
    beforeAvatarUpload(file) {
        // 文件大小校验
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            this.$notify.error('文件大小不能超过 10M !');
        }
        return isLt2M;
    }
    handleRemove(e, fileList) {
        this.fileList = fileList;
    }
    httpRequest(file) {
        return __awaiter(this, void 0, void 0, function* () {
            // 判断扩展名
            const tmpcnt = file.file.name.lastIndexOf('.');
            const uploadFileName = file.file.name.substring(0, tmpcnt); // 获取文件名
            //console.log(uploadFileName, '文件名')
            const exname = file.file.name.substring(tmpcnt + 1).toLowerCase(); // 获取后缀名
            //console.log(exname, '后缀名')
            // const names = ['jpg', 'jpeg', 'webp', 'png', 'bmp', 'exe', 'yml']
            // if (names.indexOf(exname) < 0) {
            //   this.$notify.error('不支持的格式!')
            //   return false
            // }
            let bucketName = null;
            if (exname === 'wmv' || exname === 'avi' || exname === 'mov' || exname === 'mp4') { // 视频
                this.uploadType = 1;
                bucketName = 'video';
            }
            else if (exname === 'wmv') { // 音乐
                this.uploadType = 2;
                bucketName = 'audio';
            }
            else if (exname === 'jpg' || exname === 'png' || exname === 'jpeg') { // 图片
                this.uploadType = 3;
                bucketName = 'img';
            }
            else if (exname === 'doc' || exname === 'wps' || exname === 'xls' || exname === 'ppt' || exname === 'txt' || exname === 'pdf') { // 文档
                this.uploadType = 4;
                bucketName = 'doc';
            }
            const result = yield register_1.getSecurityToken(this.uploadType);
            const client = new ali_oss_1.default({
                region: 'oss-cn-shanghai',
                accessKeyId: result.accessKeyId,
                accessKeySecret: result.accessKeySecret,
                stsToken: result.securityToken,
                endpoint: result.endpoint,
                bucket: result.bucket,
                // useFetch: true, // 支持上传大于100KB的文件
                secure: true // 返回的url为https
            });
            const res = yield client.multipartUpload(`/comment/${file.file.name}`, this.curFile.raw, {});
            const url = `http://${bucketName}.crystal-elevator.com/comment/${file.file.name}`;
            this.uploadPhoto.push(url);
        });
    }
    mounted() {
        this.currentId = this.$route.params.id;
        if (!!sessionStorage.getItem('quoted')) {
            this.quoted = true;
            this.quotedDetail(this.currentId);
            this.marks = ['待确认', '已确认', '已报价', '已下单'];
        }
        else {
            this.orderDetail(this.currentId);
        }
    }
};
OrderDetail = __decorate([
    vue_property_decorator_1.Component({
        components: { HeaderTop: () => Promise.resolve().then(() => __importStar(require('@/components/HeaderTop/HeaderTop.vue'))), FooterBottom: () => Promise.resolve().then(() => __importStar(require('@/components/FooterBottom/Foot.vue'))) }
    })
], OrderDetail);
exports.default = OrderDetail;
